var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ tableLoading: _vm.tableLoading },attrs:{"id":"tableDiv"}},[_c('div',{staticClass:"printHide"},[(_vm.displayOutput === 'cases')?_c('v-data-table',{attrs:{"disable-page-reset":"","headers":[
          {text: 'Site',
          align: 'start',
          sortable: true,
          value: 'name'
          },
          {text: 'Cases', value: 'noVaxCases', align: 'center'
          },
          {text: _vm.vaccinationRateLabel, value: 'withVaxCases', align: 'center'},
          {text: 'Averted', value: 'casesAverted', align: 'center'} ],"items":_vm.items,"dark":"","footer-props":{
        prevIcon: '〈',
        nextIcon: '〉'
      },"page":_vm.pageNo},on:{"update:page":function($event){_vm.pageNo=$event}},scopedSlots:_vm._u([{key:"item.noVaxCases",fn:function(ref){
      var item = ref.item;
return [_c('div',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(Number(item.noVaxCases).toLocaleString()))])]}},{key:"item.withVaxCases",fn:function(ref){
      var item = ref.item;
return [_c('div',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(Number(item.withVaxCases).toLocaleString()))])]}},{key:"item.casesAverted",fn:function(ref){
      var item = ref.item;
return [_c('div',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(Number(item.casesAverted).toLocaleString()))])]}}],null,false,2919735101)}):_vm._e(),(_vm.displayOutput === 'deaths')?_c('v-data-table',{attrs:{"disable-page-reset":"","headers":[
          {text: 'Site',
          align: 'start',
          sortable: true,
          value: 'name'
          },
          {text: 'Deaths', value: 'noVaxDeaths', align: 'center'
          },
          {text: _vm.vaccinationRateLabel, value: 'withVaxDeaths', align: 'center'},
          {text: 'Averted', value: 'deathsAverted', align: 'center'} ],"items":_vm.items,"dark":"","footer-props":{
        prevIcon: '〈',
        nextIcon: '〉'
      },"page":_vm.pageNo},on:{"update:page":function($event){_vm.pageNo=$event}},scopedSlots:_vm._u([{key:"item.noVaxDeaths",fn:function(ref){
      var item = ref.item;
return [_c('div',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(Number(item.noVaxDeaths).toLocaleString()))])]}},{key:"item.withVaxDeaths",fn:function(ref){
      var item = ref.item;
return [_c('div',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(Number(item.withVaxDeaths).toLocaleString()))])]}},{key:"item.deathsAverted",fn:function(ref){
      var item = ref.item;
return [_c('div',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(Number(item.deathsAverted).toLocaleString()))])]}}],null,false,3431078941)}):_vm._e()],1),_c('div',{staticClass:"printShow"},[(_vm.displayOutput === 'cases')?_c('v-data-table',{attrs:{"disable-page-reset":"","headers":[
          {text: 'Site',
          align: 'start',
          sortable: true,
          value: 'name'
          },
          {text: 'Cases', value: 'noVaxCases', align: 'center'
          },
          {text: _vm.vaccinationRateLabel, value: 'withVaxCases', align: 'center'},
          {text: 'Averted', value: 'casesAverted', align: 'center'} ],"items":_vm.items,"dark":"","footer-props":{
        prevIcon: '〈',
        nextIcon: '〉'
      },"items-per-page":100,"page":_vm.pageNo,"disable-pagination":""},on:{"update:page":function($event){_vm.pageNo=$event}},scopedSlots:_vm._u([{key:"item.noVaxCases",fn:function(ref){
      var item = ref.item;
return [_c('div',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(Number(item.noVaxCases).toLocaleString()))])]}},{key:"item.withVaxCases",fn:function(ref){
      var item = ref.item;
return [_c('div',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(Number(item.withVaxCases).toLocaleString()))])]}},{key:"item.casesAverted",fn:function(ref){
      var item = ref.item;
return [_c('div',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(Number(item.casesAverted).toLocaleString()))])]}}],null,false,2919735101)}):_vm._e(),(_vm.displayOutput === 'deaths')?_c('v-data-table',{attrs:{"disable-page-reset":"","headers":[
          {text: 'Site',
          align: 'start',
          sortable: true,
          value: 'name'
          },
          {text: 'Deaths', value: 'noVaxDeaths', align: 'center'
          },
          {text: _vm.vaccinationRateLabel, value: 'withVaxDeaths', align: 'center'},
          {text: 'Averted', value: 'deathsAverted', align: 'center'} ],"items":_vm.items,"dark":"","footer-props":{
        prevIcon: '〈',
        nextIcon: '〉'
      },"page":_vm.pageNo,"items-per-page":100,"disable-pagination":""},on:{"update:page":function($event){_vm.pageNo=$event}},scopedSlots:_vm._u([{key:"item.noVaxDeaths",fn:function(ref){
      var item = ref.item;
return [_c('div',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(Number(item.noVaxDeaths).toLocaleString()))])]}},{key:"item.withVaxDeaths",fn:function(ref){
      var item = ref.item;
return [_c('div',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(Number(item.withVaxDeaths).toLocaleString()))])]}},{key:"item.deathsAverted",fn:function(ref){
      var item = ref.item;
return [_c('div',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(Number(item.deathsAverted).toLocaleString()))])]}}],null,false,3431078941)}):_vm._e()],1),_c('button',{attrs:{"id":"pageButton"},on:{"click":_vm.turnPage}},[_vm._v("Click Me")])])}
var staticRenderFns = []

export { render, staticRenderFns }